// errorCode.js - 错误码定义（与后端保持一致）

/**
 * 业务错误码定义
 * 成功状态码：10000
 */
export const ErrorCode = {
  // 成功
  SUCCESS: 10000,
  
  // 系统错误
  SYSTEM_ERROR: 10099,          // 系统错误
  
  // 微信相关
  WECHAT_ERROR: 10001,          // 微信登录错误
  
  // 登录相关
  LOGIN_ERROR: 10002,           // 登录错误
  
  // 课程相关
  COURSE_NOT_EXIST: 10003,      // 课程不存在
};

/**
 * 错误码对应的提示信息
 */
export const ErrorMessage = {
  [ErrorCode.SUCCESS]: '成功',
  [ErrorCode.SYSTEM_ERROR]: '系统错误，请稍后重试',
  [ErrorCode.WECHAT_ERROR]: '微信登录失败',
  [ErrorCode.LOGIN_ERROR]: '登录失败，请检查手机号和密码',
  [ErrorCode.COURSE_NOT_EXIST]: '课程不存在',
};

/**
 * 获取错误信息
 */
export const getErrorMessage = (code) => {
  return ErrorMessage[code] || '未知错误';
};

export default {
  ErrorCode,
  ErrorMessage,
  getErrorMessage
};

